import axios from "axios";

// Same-origin by design: the browser hits /api on whatever host serves the
// page (brightsidecapital.net or the preview host). The ingress routes /api/*
// to the FastAPI pod, so auth cookies stay first-party and no CORS is needed.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
